module.exports = __webpack_public_path__ + "static/media/retiro.2a0e9787.png";